import { ApolloClient, ApolloProvider } from '@apollo/client';
import { CachePersistor, PersistentStorage } from 'apollo3-cache-persist';
import { InMemoryCache, NormalizedCacheObject, createHttpLink } from '@apollo/client/core';
import React, { useCallback, useEffect, useState } from 'react';

import MainRouter from './routes/MainRouter';
import { setContext } from '@apollo/client/link/context';

let persistor: CachePersistor<NormalizedCacheObject>;

class LocalStoragePersistedStorage implements PersistentStorage {
    getItem(key: string): string | null {
        return localStorage.getItem(key);
    }

    removeItem(key: string) {
        localStorage.removeItem(key);
    }

    setItem(key: string, data: any) {
        localStorage.setItem(key, data);
    }
}

async function createClient() {
    const cache = new InMemoryCache({});
    persistor = new CachePersistor({
        storage: new LocalStoragePersistedStorage(),
        cache,
    });
    const httpLink = createHttpLink({
        uri: `${process.env.REACT_APP_SERVER}/graphql`,
    });
    const authLink = setContext((_, { headers }) => {
        const token = localStorage.getItem('token');
        return {
            headers: {
                ...headers,
                authorization: token || '',
            },
        };
    });
    // await persistor.restore();
    return new ApolloClient({
        link: authLink.concat(httpLink),
        cache,
        credentials: 'include',
        defaultOptions: {
            watchQuery: {
                fetchPolicy: 'cache-and-network',
                errorPolicy: 'ignore',
            },
            mutate: {
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
            },
        },
    });
}

interface AppProps {}

export const App: React.FC<AppProps> = () => {
    const [client, setClient] = useState<ApolloClient<NormalizedCacheObject>>();

    const init = useCallback(async () => {
        const client = await createClient();
        // persistor.purge();
        // client.resetStore();
        setClient(client);
    }, []);

    useEffect(() => {
        init();
    }, [init]);

    if (!client) {
        return null;
    }

    return (
        <ApolloProvider client={client}>
            <MainRouter />
        </ApolloProvider>
    );
};
